import { useCourse } from '@/composables/course'
import { useAppSettings } from './useAppSettings'
import { useAccountStore } from '@/stores/account'
import { runSafe } from './app-init.helpers'

export function useAppInit(options?: { onSettingsLoaded?: () => void }) {
  const { fetchAllAvailableLocales } = useCourse()
  const { loadSettings } = useAppSettings()

  const applyAppSettings = async () => {
    if (!process.client) return
    await runSafe(async () => {
      await loadSettings()
      options?.onSettingsLoaded?.()
    }, 'Failed to load app settings')
  }

  /**
   * Загружает глобальный список мов курсів (без фільтру по категорії) для хедера.
   * Оновлює globalLocales в course store. Не чіпає allAvailableLocales (category-specific).
   */
  const loadGlobalLocales = () =>
    runSafe(() => fetchAllAvailableLocales(), 'Failed to load global course locales')

  const detectAccount = async () => {
    const accountStore = useAccountStore()
    await runSafe(async () => {
      await accountStore.findAccountById('63c55610cfefd8be3f61180d')
    }, 'Failed to detect account')
  }

  const initializeApp = async () => {
    await applyAppSettings()
    await detectAccount()
    loadGlobalLocales()
  }

  return {
    initializeApp,
    applyAppSettings,
    detectAccount,
    loadGlobalLocales,
  }
}
